import { APP_AUTHOR } from '../generated/appMeta.js'

// Manually maintained metadata.
export const APP_ISSUES_URL = null
export const APP_CREDITS = 'Built with Vite/Vuetify4'
export const APP_COPYRIGHT = `Copyright © 2026 ${APP_AUTHOR}`
export const APP_LICENSE = 'Proprietary Software'

export {
  APP_AUTHOR,
  APP_NAME,
  APP_VERSION,
  APP_WEBSITE_URL,
} from '../generated/appMeta.js'
